export const GA_MEASUREMENT_ID = 'G-18NMFL6Y9G'

const isGtagAvailable = () =>
  typeof window !== 'undefined' && typeof window.gtag === 'function'

export const trackPageView = (path) => {
  if (!isGtagAvailable()) return

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
  })
}

export const trackEvent = (category, action, label) => {
  if (!isGtagAvailable()) return

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
  })
}

const trackApiEvent = (status, endpoint, meta = {}) => {
  if (!isGtagAvailable()) return

  window.gtag('event', `api_${status}`, {
    event_category: 'API',
    event_label: endpoint,
    ...meta,
  })
}

export const trackApiSuccess = (endpoint, meta) =>
  trackApiEvent('success', endpoint, meta)

export const trackApiError = (endpoint, meta) =>
  trackApiEvent('error', endpoint, meta)

